<app-breadcrumb [title]="page_name" [breadcrumb]="page_name"></app-breadcrumb>
<!-- section start -->
<section class="login-page section-b-space">
    <div class="container">
        <div class="row">

            <div class="col-lg-6">
                <div class="theme-card">
                    <h2 class="title">{{'login' | translate}}</h2>
                    <form class="theme-form">
                        <div class="form-group">
                            <div class="errorOccurred" *ngIf="errorOccurred">
                                {{errorOccurredMessage}}
                                <br>
                                <br>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="mobile">{{'mobile' | translate}}</label>
                            <input type="tel" class="form-control" id="mobile" placeholder="{{'mobile' | translate}}" required="" name="mobile" [(ngModel)]="mobile">

                        </div>
                        <div class="form-group">
                            <label for="password">{{'Password' | translate}}</label>
                            <input type="password" class="form-control" id="password" placeholder="{{'Password' | translate}}" required="" name="password" [(ngModel)]="password">

                        </div>
                        <button class="btn btn-solid" (click)="userLogin()">{{'login'  | translate}}</button>
                    </form>
                </div>
            </div>
            <div class="col-lg-6 right-login">
                <div class="theme-card authentication-right">
                    <h2 class="title">{{'Create A Account' | translate}}</h2>
                    <!-- <h6 class="title-font">{{'Create A Account' | translate}}</h6> -->
                    <p>{{'Sign up for a free' | translate}}</p>
                    <button class="btn btn-solid" [routerLink]="['/pages/register']">{{'Create A Account' | translate}}</button>
                </div>
            </div>
        </div>
    </div>
</section>
<!--Section ends-->